// Module
var code = "<div class=\"ups-main-search-result\">\r\n    <ng-content select=\"ups-dashboard-accordeon-head\"> </ng-content>\r\n    <ng-content select=\"ups-dashboard-accordeon-det\"></ng-content>\r\n</div>";
// Exports
module.exports = code;